import DBLBooks from "../data/DBLBooks.json"
import bibleBookList from "../data/BookChapterList.json"

export default function getVersionVerse(versification, ref) {
  const refs = Object.entries(versification)
  const refSplit = ref.split("-")
  const DBLBook = bibleBookList[refSplit[0]].YV
  const foundRef = refs.find(
    r => r[1] === `${DBLBook}-${refSplit[1]}-${refSplit[2]}`
  )
  if (foundRef) {
    console.log("foundRef", foundRef)
    const newRefSplit = foundRef[0].split("-")
    return `${DBLBooks[newRefSplit[0]]}-${newRefSplit[1]}-${newRefSplit[2]}`
  }
  return ref
}
